import React, {
  useMemo,
  useState,
  useEffect,
} from "react";

import { useNavigate } from "react-router-dom";

import { TfiLocationPin } from "react-icons/tfi";

import { TbBrandWhatsappFilled } from "react-icons/tb";

import { RiMailSendFill } from "react-icons/ri";

import "../Styles/Jobposting.css";

import ApiService from "../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

function JobPosting() {

  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const pageSize = 4;

  /* =========================================
      JOBS STATE
  ========================================= */

  const [jobs, setJobs] = useState([]);

  const [loading, setLoading] = useState(false);

  /* =========================================
      UI STATE
  ========================================= */

  const [searchInput, setSearchInput] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  /* =========================================
      LOAD JOBS
  ========================================= */

  useEffect(() => {

    loadJobs();

  }, []);

  /* =========================================
      LOAD ALL JOBS API
      IMPORTANT :
      ADMIN DASHBOARD SHOULD USE
      /admin/all API
  ========================================= */

  const loadJobs = async () => {

    try {

      setLoading(true);

      /* =====================================
         USE ADMIN API
      ===================================== */

      const response =
        await JobAPI.getAdminAllJobs();

      console.log(
        "ALL JOBS RESPONSE :",
        response?.data
      );

      /* =====================================
         API ARRAY
      ===================================== */

      let apiJobs = [];

      if (
        Array.isArray(response?.data)
      ) {

        apiJobs = response.data;

      } else if (
        Array.isArray(
          response?.data?.jobs
        )
      ) {

        apiJobs =
          response.data.jobs;

      } else {

        apiJobs = [];
      }

      console.log(
        "RAW API JOBS :",
        apiJobs
      );

      /* =====================================
         FILTER ONLY HR / EMPLOYEE JOBS
      ===================================== */

      const hrJobs =
        apiJobs.filter((job) => {

          const role = String(
            job.creator_role || ""
          ).toUpperCase();

          return (
            role === "HR" ||
            role === "EMPLOYEE"
          );
        });

      console.log(
        "FILTERED HR JOBS :",
        hrJobs
      );

      /* =====================================
         FORMAT JOBS
      ===================================== */

      const formattedJobs =
        hrJobs.map((job) => ({

          /* =================================
             IDS
          ================================= */

          id:
            job.job_id ||
            job.id ||
            "",

          job_id:
            job.job_id ||
            job.id ||
            "",

          /* =================================
             JOB DETAILS
          ================================= */

          title:
            job.title || "",

          company_name:
            job.company_name || "",

          department:
            job.department || "",

          work_mode:
            job.work_mode || "",

          roles_responsibilities:
            job.roles_responsibilities || "",

          qualification_required:
            job.qualification_required || "",

          required_skills:
            job.required_skills || "",

          skills:
            job.required_skills
              ? String(
                  job.required_skills
                )
                  .split(",")
                  .map((s) =>
                    s.trim()
                  )
              : [],

          min_experience:
            Number(
              job.min_experience || 0
            ),

          max_experience:
            Number(
              job.max_experience || 0
            ),

          min_salary:
            Number(
              job.min_salary || 0
            ),

          max_salary:
            Number(
              job.max_salary || 0
            ),

          openings:
            Number(
              job.openings || 0
            ),

          location:
            job.location || "",

          locality:
            job.locality || "",

          deadline:
            job.application_deadline || "",

          application_deadline:
            job.application_deadline || "",

          whatsapp_number:
            job.whatsapp_number || "",

          perks_benefits:
            job.perks_benefits || "",

          attachment:
            job.logo ||
            job.attachment ||
            "",

          /* =================================
             HR DETAILS
          ================================= */

          hrName:
            job.employee_name ||
            job.created_by_name ||
            job.hr_name ||
            job.created_by ||
            "HR User",

          memberId:
            job.created_by || "",

          creator_role:
            job.creator_role || "",

          /* =================================
             STATUS
          ================================= */

          admin:
            job.status || "PENDING",

          status:
            job.status || "PENDING",

          postedDate:
            job.created_at || "",

          created_at:
            job.created_at || "",

          /* =================================
             COUNTS
          ================================= */

          all_responses:
            Number(
              job.all_responses || 0
            ),

          shortlisted:
            Number(
              job.shortlisted || 0
            ),

          rejected:
            Number(
              job.rejected || 0
            ),
        }));

      console.log(
        "FORMATTED JOBS :",
        formattedJobs
      );

      setJobs(formattedJobs);

      localStorage.setItem(
        "AllPostedJobs",
        JSON.stringify(
          formattedJobs
        )
      );

    } catch (error) {

      console.log(
        "LOAD JOBS ERROR :",
        error?.response?.data || error
      );

      console.log(
        "LOAD JOBS STATUS :",
        error?.response?.status
      );

      const stored =
        JSON.parse(
          localStorage.getItem(
            "AllPostedJobs"
          )
        ) || [];

      setJobs(stored);

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
      FILTER JOBS
  ========================================= */

  const filteredJobs =
    useMemo(() => {

      return jobs.filter((job) =>

        job.title
          ?.toLowerCase()
          .includes(
            searchInput.toLowerCase()
          )

        ||

        job.location
          ?.toLowerCase()
          .includes(
            searchInput.toLowerCase()
          )

        ||

        job.company_name
          ?.toLowerCase()
          .includes(
            searchInput.toLowerCase()
          )
      );

    }, [jobs, searchInput]);

  /* =========================================
      PAGINATION
  ========================================= */

  const totalPages =
    Math.ceil(
      filteredJobs.length /
      pageSize
    );

  const currentJobs =
    useMemo(() => {

      const startIndex =
        (page - 1) *
        pageSize;

      return filteredJobs.slice(
        startIndex,
        startIndex + pageSize
      );

    }, [filteredJobs, page]);

  /* =========================================
      SELECT ALL
  ========================================= */

  const allSelected =

    currentJobs.length > 0 &&

    currentJobs.every((job) =>
      selectedIds.includes(job.id)
    );

  const handleToggleSelectAll =
    (e) => {

      if (e.target.checked) {

        setSelectedIds(
          currentJobs.map(
            (j) => j.id
          )
        );

      } else {

        setSelectedIds([]);
      }
    };

  /* =========================================
      SINGLE SELECT
  ========================================= */

  const handleToggleSelect =
    (id) => {

      setSelectedIds((prev) =>

        prev.includes(id)

          ? prev.filter(
              (x) => x !== id
            )

          : [...prev, id]
      );
    };

  /* =========================================
      DELETE JOB
  ========================================= */

  const handleDelete =
    async () => {

      if (!selectedIds.length) {

        alert(
          "Please select job(s)"
        );

        return;
      }

      const confirmDelete =
        window.confirm(
          `Delete ${selectedIds.length} selected job(s)?`
        );

      if (!confirmDelete) return;

      try {

        for (const id of selectedIds) {

          await JobAPI.deleteJob(id);
        }

        const updatedJobs =
          jobs.filter(
            (job) =>
              !selectedIds.includes(
                job.id
              )
          );

        setJobs(updatedJobs);

        localStorage.setItem(
          "AllPostedJobs",
          JSON.stringify(
            updatedJobs
          )
        );

        setSelectedIds([]);

        alert(
          "Jobs Deleted Successfully"
        );

      } catch (error) {

        console.log(
          "DELETE ERROR :",
          error?.response?.data || error
        );

        alert(
          "Unable To Delete Jobs"
        );
      }
    };

  /* =========================================
      APPROVE JOB
  ========================================= */

  const handleApprove =
    async () => {

      if (!selectedIds.length) {

        alert(
          "Select job(s) to approve"
        );

        return;
      }

      try {

        for (const id of selectedIds) {

          await JobAPI.approveJob(id);
        }

        const updatedJobs =
          jobs.map((job) =>

            selectedIds.includes(job.id)

              ? {
                  ...job,
                  admin:
                    "APPROVED",
                  status:
                    "APPROVED",
                }

              : job
          );

        setJobs(updatedJobs);

        localStorage.setItem(
          "AllPostedJobs",
          JSON.stringify(
            updatedJobs
          )
        );

        setSelectedIds([]);

        alert(
          "Jobs Approved Successfully"
        );

      } catch (error) {

        console.log(
          "APPROVE ERROR :",
          error?.response?.data || error
        );

        alert(
          "Unable To Approve Jobs"
        );
      }
    };

  /* =========================================
      REJECT JOB
  ========================================= */

  const handleReject =
    async () => {

      if (!selectedIds.length) {

        alert(
          "Select job(s) to reject"
        );

        return;
      }

      try {

        for (const id of selectedIds) {

          await JobAPI.rejectJob(id);
        }

        const updatedJobs =
          jobs.map((job) =>

            selectedIds.includes(job.id)

              ? {
                  ...job,
                  admin:
                    "REJECTED",
                  status:
                    "REJECTED",
                }

              : job
          );

        setJobs(updatedJobs);

        localStorage.setItem(
          "AllPostedJobs",
          JSON.stringify(
            updatedJobs
          )
        );

        setSelectedIds([]);

        alert(
          "Jobs Rejected Successfully"
        );

      } catch (error) {

        console.log(
          "REJECT ERROR :",
          error?.response?.data || error
        );

        alert(
          "Unable To Reject Jobs"
        );
      }
    };

  /* =========================================
      PREVIEW
  ========================================= */

  const handlePreview =
    (job) => {

      navigate(
        "/dashboard/JobPreview",
        {
          state: { job },
        }
      );
    };

  /* =========================================
      SEND
  ========================================= */

  const handleSend =
    () => {

      if (!selectedIds.length) {

        alert(
          "Please Select Job(s)"
        );

        return;
      }

      alert(
        "Notification Sent Successfully"
      );
    };

  /* =========================================
      UI
  ========================================= */

  return (

    <section className="adminjobpost">

      <div className="container">

        <h3
          className="training-title mt-2 fw-bold"
          style={{
            color: "#8D0000",
          }}
        >
          Employee Job Posts
        </h3>

        {/* =========================================
              TOP BAR
        ========================================= */}

        <div className="d-flex justify-content-between mb-3 flex-wrap gap-3">

          {/* TOTAL JOBS */}

          <div>

            <h5 className="text-muted">

              Total HR Jobs :-

              {" "}

              {filteredJobs.length}

              {" "}of{" "}

              {jobs.length}

            </h5>

          </div>

          {/* EMAIL / WHATSAPP */}

          <div className="d-flex gap-3 align-items-center">

            <div className="form-check">

              <input
                type="checkbox"
                className="form-check-input job-checkbox"
              />

              <label className="form-check-label ms-1 admin-select">

                <RiMailSendFill
                  style={{
                    color: "blue",
                    fontSize: "20px",
                  }}
                />

                {" "}Email

              </label>

            </div>

            <div className="form-check">

              <input
                type="checkbox"
                className="form-check-input job-checkbox"
              />

              <label className="form-check-label ms-1 admin-select">

                <TbBrandWhatsappFilled
                  style={{
                    color: "green",
                    fontSize: "20px",
                  }}
                />

                {" "}Whatsapp

              </label>

            </div>

            <button
              className="admin-serch"
              onClick={handleSend}
            >
              Send
            </button>

          </div>

          {/* APPROVE / REJECT */}

          <div className="d-flex gap-3">

            <button
              className="admin-app"
              onClick={handleApprove}
            >
              Approve
            </button>

            <button
              className="admin-rej"
              onClick={handleReject}
            >
              Reject
            </button>

          </div>

        </div>

        {/* =========================================
              ACTION BAR
        ========================================= */}

        <div className="bg-light border rounded-3 p-3 mb-4 d-flex flex-wrap align-items-center gap-3">

          {/* SELECT ALL */}

          <div className="form-check">

            <input
              type="checkbox"
              className="form-check-input job-checkbox"
              checked={allSelected}
              onChange={
                handleToggleSelectAll
              }
            />

            <label className="form-check-label ms-1 admin-select">
              Select All
            </label>

          </div>

          {/* SEARCH */}

          <div className="flex-grow-1 d-flex gap-2">

            <input
              type="text"
              className="form-control"
              placeholder="Search by Job Title or Location..."
              value={searchInput}
              onChange={(e) => {

                setSearchInput(
                  e.target.value
                );

                setPage(1);

              }}
            />

            <button className="admin-serch">
              Search
            </button>

          </div>

          {/* DELETE */}

          <button
            className="admin-delt"
            onClick={handleDelete}
          >
            Delete
          </button>

        </div>

        {/* =========================================
              LOADING
        ========================================= */}

        {loading && (

          <div className="text-center py-5">

            <h5>
              Loading HR Jobs...
            </h5>

          </div>

        )}

        {/* =========================================
              JOB CARDS
        ========================================= */}

        {!loading &&
          currentJobs.map((job) => (

          <div
            key={job.id}
            className="card mb-3 shadow-sm border-0"
          >

            <div className="card-body p-0">

              {/* TOP */}

              <div className="d-flex justify-content-between m-3">

                <div className="d-flex gap-2">

                  <input
                    type="checkbox"
                    checked={selectedIds.includes(job.id)}
                    onChange={() =>
                      handleToggleSelect(job.id)
                    }
                  />

                  <div>

                    <h6>
                      {job.title}
                    </h6>

                    <small className="admin-text-muted">

                      <TfiLocationPin />

                      {" "}

                      {job.location}

                    </small>

                  </div>

                </div>

                <button
                  className="btn btn-outline-primary btn-sm"
                  style={{
                    padding: "2px 10px",
                    fontSize: "12px",
                  }}
                  onClick={() =>
                    handlePreview(job)
                  }
                >
                  Job Preview
                </button>

              </div>

              {/* CENTER */}

              <div className="d-flex justify-content-center gap-3 my-3 flex-wrap">

                <button className="btn btn-sm btn-outline-primary">

                  {job.all_responses}

                  {" "}Responses

                </button>

                <button className="btn btn-sm btn-outline-success">

                  {job.shortlisted}

                  {" "}Shortlisted

                </button>

                <button className="btn btn-sm btn-outline-danger">

                  {job.rejected}

                  {" "}Rejected

                </button>

              </div>

              {/* BOTTOM */}

              <div className="d-flex justify-content-between align-items-center px-3 pb-3 flex-wrap gap-3">

                {/* STATUS */}

                <div>

                  <span
                    className="fw-bold"
                    style={{
                      color:

                        job.admin === "APPROVED"

                          ? "green"

                          : job.admin === "REJECTED"

                          ? "red"

                          : "orange",
                    }}
                  >

                    {job.admin}

                  </span>

                </div>

                {/* HR NAME + MEMBERSHIP ID */}

                <div className="admin-name-card-per text-center">

                  <p className="mb-0 fw-bold">

                    {job.hrName}

                  </p>

                  <p className="mb-0">

                    {job.memberId}

                  </p>

                  <small
                    className="text-muted"
                  >

                    {job.creator_role}

                  </small>

                </div>

                {/* DATE */}

                <div className="text-end">

                  <span
                    className={`badge ${
                      job.status === "APPROVED"
                        ? "bg-success"
                        : job.status === "REJECTED"
                        ? "bg-danger"
                        : "bg-warning text-dark"
                    }`}
                  >

                    {job.status}

                  </span>

                  <div className="admin-text-muted small mt-2">

                    Posted :

                    {" "}

                    <span className="posted-date fw-bold">

                      {job.created_at

                        ? new Date(
                            job.created_at
                          ).toLocaleDateString()

                        : "N/A"}

                    </span>

                  </div>

                </div>

              </div>

            </div>

          </div>

        ))}

        {/* =========================================
              EMPTY
        ========================================= */}

        {!loading &&
          currentJobs.length === 0 && (

          <div className="text-center py-5 text-muted">

            No HR posted jobs available

          </div>

        )}

        {/* =========================================
              PAGINATION
        ========================================= */}

        {totalPages > 1 && (

          <div className="d-flex justify-content-between mt-4">

            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page === 1}
              onClick={() =>
                setPage(page - 1)
              }
            >
              Previous
            </button>

            <div className="fw-bold">

              Page {page} of {totalPages}

            </div>

            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={
                page === totalPages
              }
              onClick={() =>
                setPage(page + 1)
              }
            >
              Next
            </button>

          </div>

        )}

      </div>

    </section>
  );
}

export default JobPosting;